module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "labelAutocomplete"
    }
  }, [_c('v-combobox', {
    attrs: {
      "placeholder": "Catatan soal",
      "items": _vm.filteredLabels,
      "outlined": "",
      "maxlength": "255"
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function(ref) {
        var item = ref.item;

        return [_c('a', {
          attrs: {
            "href": "javascript:;"
          },
          on: {
            "click": function($event) {
              return _vm.$emit('selected', item)
            }
          }
        }, [_vm._v(_vm._s(item))])]
      }
    }])
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-017eb304","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/global/components/plugins/LabelAutocomplete.vue
// module id = 1546
// module chunks = 1